import {Button, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, Text} from '@chakra-ui/react';
import {usePreOrder} from 'api/queries';
import {useCartContext} from 'components/providers';
import {IModalProps, Modal} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC, useState} from 'react';
import {useOrderProviderStore} from 'store/orderStore';
import {modalCloseButtonStyles} from 'theme';
import {IPreOrderData} from 'types';
import {getDeliveryTimeString} from 'utils/helpers';

import {AddPreOrder} from './components';

interface IProps extends IModalProps {
  preOrder?: IPreOrderData;
}

export const DelayedTime: FC<IProps> = ({onClose, isOpen, preOrder}) => {
  const {t} = useTranslation();
  const {cartProvider} = useCartContext();
  const {setPreOrder} = useOrderProviderStore();
  const [preOrderSelectData, setPreOrderSelectData] = useState<IPreOrderData | undefined>(preOrder);

  const {data: preOrderData = []} = usePreOrder(
    {slug: cartProvider?.slug},
    {
      enabled: !!cartProvider?.slug,
    },
  );

  const selectBtnDisabled = !cartProvider?.is_open && !preOrderSelectData;

  const onChange = (data?: IPreOrderData) => {
    setPreOrderSelectData(data);
  };

  const onSave = () => {
    setPreOrder(preOrderSelectData);
    onClose();
  };
  const providerClosed = !cartProvider?.is_open || cartProvider?.is_overloaded !== 0;
  const deliveryTime = getDeliveryTimeString(cartProvider?.avg_delivery_time);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent maxW="450px" overflow="hidden" mx={['10px', 0]}>
        <ModalHeader>{t('SELECT_TIME_AND_DAY')}</ModalHeader>
        <ModalCloseButton sx={modalCloseButtonStyles} />
        <ModalBody pb="6px">
          {preOrderData && (
            <AddPreOrder
              currentPreOrder={preOrderSelectData}
              preOrder={preOrderData}
              onChange={onChange}
              delayTime={deliveryTime}
              t={t}
              // do not show delay time if restaurant is closed paused or overloaded
              restaurantClosed={providerClosed}
            />
          )}
        </ModalBody>

        <ModalFooter pt="15px">
          <Button
            variant="primary"
            w="100%"
            p="28px 24px"
            flex-shrink={0}
            onClick={onSave}
            disabled={selectBtnDisabled}
          >
            <Text fontSize="16px" line-height="22px">
              {!selectBtnDisabled ? t('SELECT') : t('PRE_ORDER_REQUIRED')}
            </Text>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
